module.exports = __webpack_public_path__ + "img/IM.be38d2c7.svg";